import { useEffect, useRef } from 'react';

/**
 * Scroll progress bar that fills in real-time as the user scrolls.
 * Updates the bar width directly on the DOM via a ref — no React state,
 * no batching delay — so it stays perfectly in sync with scroll position.
 */
export default function ElectionStoryProgress() {
  const barRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    const update = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = scrollableHeight > 0 ? (window.scrollY / scrollableHeight) * 100 : 0;
      bar.style.width = `${Math.min(percent, 100)}%`;
    };

    // Set initial value
    update();

    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div className="sticky top-0 z-40 h-1 bg-neutral-100">
      <div ref={barRef} className="h-full bg-primary-600" style={{ width: '0%' }} />
    </div>
  );
}
